import { create } from 'zustand'

interface ModalDownloadPropertiesXlsxState {
  modalDownloadPropertiesXlsx: {
    isOpen: boolean
    onSuccess?: () => void
  }
  setModalDownloadPropertiesXlsx: (modalDownloadPropertiesXlsx: {
    isOpen: boolean
    onSuccess?: () => void
  }) => void
  reset: () => void
}

const initialState = {
  modalDownloadPropertiesXlsx: {
    isOpen: false
  }
}

export const useModalDownloadPropertiesXlsxStore = create<ModalDownloadPropertiesXlsxState>()(
  (set) => ({
    ...initialState,
    setModalDownloadPropertiesXlsx: (modalDownloadPropertiesXlsx) => set({ modalDownloadPropertiesXlsx }),
    reset: () =>
      set({
        modalDownloadPropertiesXlsx: initialState.modalDownloadPropertiesXlsx
      })
  })
)
